/**
 * Site configuration — centralized constants and labels (no hardcoding elsewhere).
 * Pseudocode:
 * - Export readonly config object for brand, links, feature flags.
 */
import { analyticsConfig } from './analytics.config';

export const site = {
  brandName: 'SPA Studio',
  domain: 'spastudio.org',
  contactEmail: 'contact@spastudio.org',
  lastUpdated: 'May 14, 2026',
  tagline: 'Browser tools that work offline and don\'t steal your data',
  description: 'Privacy-first utilities built to fill gaps in native apps and replace sketchy online services. Everything runs locally in your browser.',
  privacyTagline: '🔒 Everything runs locally - your files never leave your device',
  valueProps: [
    {
      icon: '🔒',
      title: 'Privacy First',
      description: 'Everything runs in your browser. No uploads, no tracking.'
    },
    {
      icon: '📱',
      title: 'Actually Useful',
      description: 'Real solutions for gaps in native apps.'
    },
    {
      icon: '🌐',
      title: 'Works Offline',
      description: 'Functions without internet after first load.'
    }
  ],
  telemetry: { enabled: analyticsConfig.enabled },
  features: {
    workerAssist: false // optional Cloudflare Workers assist toggle
  }
} as const;

// Export as siteConfig for backwards compatibility
export const siteConfig = site;
